export class MissingRequirementsDocumentModel {
    public missingRequirementId: number;
    public incidentNumberId: number;
    public incidentMissingRequirementTypeId: number;
    public incidentMissingRequirementTypeDisplayValue: string;
    public otherRequirement: string;
    public deleted: boolean;
    public viewId: number;
}
